// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:

// Handles the clicking of the SELECT button when issueing assets to BOMS

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "vlchart" ]
  static values = {
    url: String,
    data: Array
  }

  connect() {
    let vlSpec = {
      $schema: 'https://vega.github.io/schema/vega-lite/v5.json',
      data: {
        values: this.dataValue,
      },
      width: 'container',
      mark: 'bar',
      encoding: {
        y: {
          field: 'Vehicles', 
          type: 'quantitative'
        },
        x: {
          field: 'Time of day',
          type: 'nominal', 
        }
      },
      title: "Occupancy Snapshot"
    };
    
    vegaEmbed(this.vlchartTarget, vlSpec, {"actions": false});
  }
}
